import React, { useState,useEffect } from 'react';
import {NavLink, useNavigate} from 'react-router-dom';

// import bnrbgen from '../../assets/images/bnrbgen.svg';
// import bnrbgar from '../../assets/images/bnrbgar.svg';
// import bnrpic from '../../assets/images/bca_banner.svg';
// import prvd1 from '../../assets/images/bca_audit_service.svg';
// import prvd2 from '../../assets/images/bca_zakat_tax_service.svg';
// import prvd3 from '../../assets/images/bca_bookkeeping_service.svg';
// import rndtop from '../../assets/images/roundTop.svg';
// import abtus from '../../assets/images/bca_support_service.svg';
import { Button, Row, Col} from 'react-bootstrap';
//For Translate
import './../../translations/i18n';
import { useTranslation } from 'react-i18next';
//For Content
import Content from './../../data/content.json';
import RequestServiceModal from './common/RequestServiceModal';
//redux
import { useSelector } from 'react-redux';
//Google Recaptcha
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { recaptchaValidate } from './../../services/public.service';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import loadable from '@loadable/component';

// images
const bnrbgen = `${process.env.REACT_APP_CDN_PATH}/public/bnrbgen.svg`;
const bnrbgar = `${process.env.REACT_APP_CDN_PATH}/public/bnrbgar.svg`;
const bnrpic = `${process.env.REACT_APP_CDN_PATH}/public/bca_banner.svg`;
const prvd1 = `${process.env.REACT_APP_CDN_PATH}/public/bca_audit_service.svg`;
const prvd2 = `${process.env.REACT_APP_CDN_PATH}/public/bca_zakat_tax_service.svg`;
const prvd3 = `${process.env.REACT_APP_CDN_PATH}/public/bca_bookkeeping_service.svg`;
const rndtop = `${process.env.REACT_APP_CDN_PATH}/public/roundTop.svg`;
const abtus = `${process.env.REACT_APP_CDN_PATH}/public/bca_support_service.svg`;

//lazzy Loading component
const PageTitle = loadable(() => import('./../shared_components/PageTitle'));
const HomeHeader = loadable(() => import('./common/HomeHeader'));
const HomeFooter = loadable(() => import('./common/HomeFooter'));
const HomeExperiance = loadable(() => import('./common/HomeExperiance'));
const HomeContact = loadable(() => import('./common/HomeContact'));
const HomePricingPlan = loadable(() => import('./common/HomePricingPlan'));

const Home = () => {
	const { t } = useTranslation();
	const language = useSelector((state) => state.user.language);
	const navigate = useNavigate();

	/**  for request service modal */
	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);
	const handleClose = () => setShow(false);
	/**  end request service modal */
	//Google recaptcha validation
	const [recaptchValidate, setRecaptchValidate] = useState();
	const handleVerify = async (token) => {
		try {
			if (token) {
				const response = await recaptchaValidate(token);
				setRecaptchValidate(response?.data);
			}
		} catch (err) {
			console.error('captcha', err);
		}
	};

	return (
		<>
			<PageTitle
				title={Content?.Home?.heading?.meta_title?.[language]}
				description={Content?.Home?.heading?.meta_description?.[language]}
				meta_keywords={Content?.Home?.heading?.meta_keywords?.[language]}
			/>
			<div className="mainsite fntpg">
				{'ar' === language ? (
					<span className="bnrbg">
						<img src={bnrbgar} alt={t('Mustanad banner bg')} width="100%"/>
					</span>
				) : (
					<span className="bnrbg">
						<img src={bnrbgen} alt={t('Mustanad banner bg')} width="100%"/>
					</span>
				)}

				<HomeHeader />
				<main className="mainbody hm">
					{/* Heading */}
					<section className="mainbanner">
						<div className="wrapper">
							<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
								<section className="d-flex justify-content-between align-items-center">
									<article>
										<h1 className="thm1-clr " dangerouslySetInnerHTML={{ __html: Content?.Home?.heading?.title?.[language] }}></h1>
										<p dangerouslySetInnerHTML={{ __html: Content?.Home?.heading?.description?.[language] }}></p>
										<div className="mt-4">
											<Button variant="thm2 nofcs " size="lg" onClick={handleShow} aria-label="Contact us">
												{t('Contact us')}
											</Button>
										</div>
									</article>
									<aside>
										<img src={bnrpic} alt="Mustanad banner" width="100%"/>
									</aside>
								</section>
							</AnimationOnScroll>
						</div>
					</section>
					{/* Service  */}
					<section className="hmcntbx">
						<div className="wrapper">
							<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
								<div className="hdn text-center">
									<p className="thm2-clr text-uppercase">
										<span className="smhdn">{t('Services')}</span>
									</p>
									<h2 className=" fw6">{Content?.Home?.services?.title?.[language]}</h2>
								</div>
							</AnimationOnScroll>
							<div className="mx-auto" style={{ maxWidth: '1130px' }}>
								<section className="prvd-box">
									<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
										<Row className="justify-content-between align-items-center">
											<Col className="pics">
												<img src={prvd1} alt="Mustanad provide" className="mx-auto" height="100%"/>
											</Col>
											<Col className="txts">
												<h3 className="thm1-clr fw6">{Content?.Home?.services?.audit?.title?.[language]}</h3>
												<p dangerouslySetInnerHTML={{ __html: Content?.Home?.services?.audit?.description?.[language] }}></p>
												<p className="link">
													<NavLink to={`/${language}/services/auditing`}>{t('Read more')}</NavLink>
												</p>
											</Col>
										</Row>
									</AnimationOnScroll>
								</section>
								<section className="prvd-box">
									<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
										<Row className="justify-content-between align-items-center">
											<Col className="txts">
												<h3 className="thm1-clr fw6">{Content?.Home?.services?.zakatTax?.title?.[language]}</h3>
												<p>{Content?.Home?.services?.zakatTax?.description?.[language]}</p>
												<p className="link">
													<NavLink to={`/${language}/services/zakat-tax`}>{t('Read more')}</NavLink>
												</p>
											</Col>
											<Col className="pics">
												<img src={prvd2} alt="Mustanad provide" className="mx-auto" height="100%"/>
											</Col>
										</Row>
									</AnimationOnScroll>
								</section>
								<section className="prvd-box">
									<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
										<Row className="justify-content-between align-items-center">
											<Col className="pics">
												<img src={prvd3} alt="Mustanad provide" className="mx-auto" height="100%"/>
											</Col>
											<Col className="txts">
												<h3 className="thm1-clr fw6">{Content?.Home?.services?.bookkeeping?.title?.[language]}</h3>
												<p>{Content?.Home?.services?.bookkeeping?.description?.[language]}</p>
												<p className="link">
													<NavLink to={`/${language}/services/accounting`}>{t('Read more')}</NavLink>
												</p>
											</Col>
										</Row>
									</AnimationOnScroll>
								</section>
								<div className="text-center mt-4">
									<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
										<Button variant="thm2 nofcs " size="lg" onClick={handleShow} aria-label="Request service">
											{t('Request service')}
										</Button>
									</AnimationOnScroll>
								</div>
							</div>
						</div>
					</section>
					{/* About us */}
					<section className="hmcntbx rndtop">
						<span className="rndpic">
							<img src={rndtop} alt="Mustanad" width="100%"/>
						</span>
						<div className="wrapper">
							<div className="abtus">
								<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
									<Row className="justify-content-between align-items-center">
										<Col className="txts">
											<div className="hdn">
												<p className="thm2-clr text-uppercase">
													<span className="smhdn">{t('About us')}</span>
												</p>
												<h2 className=" fw6">{Content?.Home?.aboutus?.title?.[language]}</h2>
											</div>
											<p className="mt-3">{Content?.Home?.aboutus?.description?.[language]}</p>
											<p>{Content?.Home?.aboutus?.description2?.[language]}</p>
											<div className="mt-4 pt-1">
												<Button variant="thm2 nofcs" onClick={() => navigate(`/${language}/about-us`)} size="lg" aria-label="Read more">
													{t('Read more')}
												</Button>
											</div>
										</Col>
										<Col className="pics">
											<img src={abtus} alt={t('About Mustanad Professional Services')} className="mx-auto mw-100" height="100%" style={{ maxHeight: '500px' }} />
										</Col>
									</Row>
								</AnimationOnScroll>
							</div>
							<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
								<HomeExperiance />
							</AnimationOnScroll>
						</div>
					</section>
					{/* OUR PRICING */}
					<section className="hmcntbx">
						<div className="wrapper">
							<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
								<div className="hdn text-center">
									<p className="thm2-clr text-uppercase">
										<span className="smhdn">{t('Our pricing')}</span>
									</p>
									<h2 className=" fw6">{Content?.Home?.pricing?.title?.[language]}</h2>
								</div>
								<div
									className="text-center fw5 mt-3 mb-3 sbhd"
									style={{ lineHeight: '2' }}
									dangerouslySetInnerHTML={{ __html: Content?.Home?.pricing?.description?.[language] }}
								></div>
							</AnimationOnScroll>
							<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
								<HomePricingPlan recaptchValidate={recaptchValidate} />
							</AnimationOnScroll>
						</div>
					</section>
					<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
						<HomeContact recaptchValidate={recaptchValidate} />
					</AnimationOnScroll>
				</main>
				<AnimationOnScroll animateIn="animate__aniIn" animateOnce={true}>
					<HomeFooter />
				</AnimationOnScroll>
			</div>
			{show && <RequestServiceModal show={show} onClose={handleClose} serviceType="" recaptchValidate={recaptchValidate} />}

			{process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY && (
				<GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY} language={language}>
					<GoogleReCaptcha onVerify={handleVerify} />
				</GoogleReCaptchaProvider>
			)}
		</>
	);
};

export default Home;
